<script lang="ts">
  import Layout from "$app/Layouts/Admin.svelte"
  import { formatDate } from "$app/utils"

  type PlanTypeAdmin = PlanType & {
    admin: UserType
    onboarding_data: any
  }
  type UserRolePlan = UserType & {
    plan_name: string
    role: string
    plan_id: number
  }

  let props = $props()

  let active_plans: number = props.active_plans
  let user_count: number = props.user_count
  let plans_last_30_days: number = props.plans_last_30_days
  let goals_last_30_days: number = props.goals_last_30_days
  let tasks_last_30_days: number = props.tasks_last_30_days
  let goal_progresses_last_30_days: number = props.goal_progresses_last_30_days
  let task_progresses_last_30_days: number = props.task_progresses_last_30_days
  let active_subscriptions: number = props.active_subscriptions
  let total_goals: number = props.total_goals
  let total_tasks: number = props.total_tasks
  let total_goal_progresses: number = props.total_goal_progresses
  let total_task_progresses: number = props.total_task_progresses
  let recognitions_last_30_days: number = props.recognitions_last_30_days
  let recognition_recipients_last_30_days: number =
    props.recognition_recipients_last_30_days
  let last_plans: PlanTypeAdmin[] = props.last_plans
  let last_users: UserRolePlan[] = props.last_users
  let recent_plan_count: string = $state(props.recent_plan_count || "20")
  let recent_user_count: string = $state(props.recent_user_count || "20")
  let free_subscription_count: number = props.free_subscription_count
  let standard_subscription_count: number = props.standard_subscription_count
  let unlimited_subscription_count: number = props.unlimited_subscription_count

  let plan_form = $state(null)
  let user_form

  const onboardingHeader = [
    { title: "Completed", field: "completed" },
    { title: "Skipped", field: "skipped_onboarding" },
    { title: "Current Step", field: "current_onboarding_step" }
  ]
</script>

<Layout {...props}>
  <span slot="title">Dashboard</span>

  <div>
    <h3 class="text-base font-semibold leading-6 text-gray-900">
      Recent Plan Stats
    </h3>
    <dl class="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-4">
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">Active Plans</dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {active_plans.toLocaleString("en")}
        </dd>
      </div>
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">Total Users</dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {#if user_count > 999}
            {user_count.toLocaleString("en")}
          {:else}
            {user_count}
          {/if}
        </dd>
      </div>
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Plans in the last 30 days
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {plans_last_30_days.toLocaleString("en")}
        </dd>
      </div>
    </dl>
    <h3 class="text-base font-semibold leading-6 text-gray-900 mt-6">
      Recent Goal and Task Stats
    </h3>
    <dl class="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-5">
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Goals created in last 30 days
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {goals_last_30_days.toLocaleString("en")}
        </dd>
      </div>

      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Tasks created in last 30 days
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {tasks_last_30_days.toLocaleString("en")}
        </dd>
      </div>

      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Goal progresses in last 30 days
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {goal_progresses_last_30_days.toLocaleString("en")}
        </dd>
      </div>

      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Task progresses in last 30 days
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {task_progresses_last_30_days.toLocaleString("en")}
        </dd>
      </div>
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Total Goals created (all-time)
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {total_goals.toLocaleString("en")}
        </dd>
      </div>

      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Total Tasks created
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {total_tasks.toLocaleString("en")}
        </dd>
      </div>

      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Total Goal Progresses created
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {total_goal_progresses.toLocaleString("en")}
        </dd>
      </div>

      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Total Task Progresses created
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {total_task_progresses.toLocaleString("en")}
        </dd>
      </div>
    </dl>
    <h3 class="text-base font-semibold leading-6 text-gray-900 mt-6">
      Recent Recognition Stats
    </h3>
    <dl class="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-4">
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Recognitions sent in last 30 days
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {recognitions_last_30_days.toLocaleString("en")}
        </dd>
      </div>

      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Recognition recipients in last 30 days
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {recognition_recipients_last_30_days.toLocaleString("en")}
        </dd>
      </div>
    </dl>
    <h3 class="text-base font-semibold leading-6 text-gray-900 mt-6">
      Recent Subscription Stats
    </h3>
    <dl class="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-5">
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Active Subscriptions
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {active_subscriptions.toLocaleString("en")}
        </dd>
      </div>
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Free Subscriptions
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {free_subscription_count.toLocaleString("en")}
        </dd>
      </div>
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Standard Subscriptions
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {standard_subscription_count.toLocaleString("en")}
        </dd>
      </div>
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">
          Unlimited Subscriptions
        </dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {unlimited_subscription_count.toLocaleString("en")}
        </dd>
      </div>
    </dl>
  </div>

  <div class="bg-white py-4 mt-8 rounded-lg">
    <div class="px-4 sm:px-6 lg:px-8">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">
            Recent Plans
          </h1>
          <p class="mt-2 text-sm text-gray-700">
            A list of plans that have been recently created.
          </p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <form bind:this={plan_form} method="get" action="/admin">
            <input
              type="hidden"
              name="recent_plan_count"
              value={recent_plan_count}
            />
            <input
              type="hidden"
              name="recent_user_count"
              value={recent_user_count}
            />
            <h2 class="flex justify-start items-center text-base text-gray-600">
              View Last
              <select
                class="w-20 mx-2"
                bind:value={recent_plan_count}
                onchange={plan_form.requestSubmit()}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
              plans
            </h2>
          </form>
        </div>
      </div>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
          >
            <div
              class="shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg overflow-y-auto max-h-140"
            >
              <table class="min-w-full divide-y divide-gray-300">
                <thead
                  class="bg-gray-50 sticky top-0 z-10 border-b border-gray-200"
                >
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >Plan Name</th
                    >
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >Created</th
                    >
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >Onboarding Progress</th
                    >
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >Plan Primary Admin</th
                    >
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  {#each last_plans as plan}
                    <tr>
                      <td
                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                        >{plan.name}</td
                      >
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 italic"
                        >{formatDate(plan.created_at)}</td
                      >
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        <div class="grid grid-cols-2 p-2">
                          {#each onboardingHeader as oHead}
                            <div
                              class="border-b border-gray-300 p-1 font-semibold text-sm whitespace-nowrap"
                            >
                              {oHead.title}
                            </div>
                            <div class="border-b border-gray-300 p-1 text-sm">
                              {plan.onboarding_data[oHead.field] || "No"}
                            </div>
                          {/each}
                        </div>
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {plan?.admin?.name}<br />{plan?.admin?.email}</td
                      >
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-white py-4 mt-8 rounded-lg">
    <div class="px-4 sm:px-6 lg:px-8">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">
            Recent Users
          </h1>
          <p class="mt-2 text-sm text-gray-700">
            A list of users that have been recently created.
          </p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <form bind:this={user_form} method="get" action="/admin">
            <input
              type="hidden"
              name="recent_plan_count"
              value={recent_plan_count}
            />
            <input
              type="hidden"
              name="recent_user_count"
              value={recent_user_count}
            />
            <h2 class="subtitle flex justify-start items-center text-gray-600">
              Last
              <select
                class="w-20 mx-2"
                bind:value={recent_user_count}
                onchange={plan_form.requestSubmit()}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
              users
            </h2>
          </form>
        </div>
      </div>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
          >
            <div
              class="shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg overflow-y-auto max-h-140"
            >
              <table class="min-w-full divide-y divide-gray-300">
                <thead
                  class="bg-gray-50 sticky top-0 z-10 border-b border-gray-200"
                >
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >Name</th
                    >
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >Email</th
                    >
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >Created</th
                    >
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >Plan Name</th
                    >
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >Plan ID</th
                    >
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  {#each last_users as user}
                    <tr>
                      <td
                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                        >{user.name}</td
                      >
                      <td
                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                        >{user.email}</td
                      >
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 italic"
                        >{formatDate(user.created_at)}</td
                      >
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {user.plan_name}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {user.plan_id}</td
                      >
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</Layout>
